export const glassQuotes = [
  "Unsere Welt ist eine Scheibe.",
  "Keine Panik. Wir haben den Durchblick.",
  "Steinschlag passiert. Schlechte Laune ist optional.",
  "Klare Sicht. Klare Sache.",
  "Andere sehen Probleme. Wir sehen Glas.",
  "Deine Scheibe hat einen Sprung? Wir nicht.",
  "Wir machen aus KNACK wieder KLAR.",
  "Glas halb voll? Hauptsache ohne Steinschlag.",
  "Eine klare Sache.",
  "Mehr Durchblick geht kaum.",
  "Stein gehabt?",
  "Wenn's knackt, sind wir da.",
  "Wir kümmern uns um den Durchblick.",
  "Gute Sicht beginnt mit gutem Glas.",
  "Das Leben ist zu kurz für schlechte Sicht.",
  "Ein kleiner Stein. Eine große Geschichte.",
  "Scheibe kaputt? Läuft bei uns.",
  "Wir stehen auf klare Verhältnisse.",
  "Durchblick ist unser Tagesgeschäft.",
  "Klare Sicht auf gute Zeiten.",
];

export const oracleMessages = [
  "Deine Zukunft sieht … durchsichtig aus.",
  "Heute solltest du Abstand zu Kieslastern halten.",
  "Ich sehe einen Mann mit Saugnäpfen in deiner Zukunft.",
  "Die Sterne stehen günstig. Die Scheibe hoffentlich auch.",
  "Merkur befindet sich heute im Steinschlag.",
  "Dein Glücksgegenstand heute: eine klare Scheibe.",
  "Ich sehe gute Nachrichten auf dich zukommen.",
  "Die Zukunft ist glasklar.",
  "Ein Stein wird heute besser Abstand halten.",
  "Das Universum sagt: freie Sicht voraus.",
  "Ich sehe … sehr viel Glas.",
  "Die Wahrscheinlichkeit für Durchblick steigt.",
  "Heute wird ein guter Tag. Das sagt zumindest die Scheibe.",
  "Die Sterne sagen: Bleib entspannt.",
  "Dein nächster Blick nach vorne wird klarer.",
  "Ich sehe keine Probleme. Nur Lösungen.",
  "Das Orakel empfiehlt: Kaffee und klare Sicht.",
  "Eine gute Nachricht nähert sich mit hoher Geschwindigkeit.",
  "Deine Scheibe glaubt an dich.",
  "Bitte frag nicht nach den Lottozahlen.",
];

export const scheibiMessages = [
  "Aua.",
  "Hey!",
  "Ich bin nur Dekoration.",
  "Bitte nicht gegen die Scheibe klopfen.",
  "Mein Cousin arbeitet in einem Golf.",
  "Ich hab den Durchblick.",
  "Pssst … dein Status steht oben.",
  "Ich arbeite hier seit 14 Pixeln.",
  "Noch ein Klick und ich ruf den Meister.",
  "Scheibe gut. Alles gut.",
  "Ich beobachte nur.",
  "Frag mich nicht nach Lieferzeiten.",
  "Ich bin zuständig für gute Laune.",
  "Keine Sorge. Die echten Profis arbeiten gerade.",
  "Ich bin offiziell TÜV-geprüft. Also fast.",
];

export const gameWinTexts = [
  "Stark! Die Scheibe hatte heute keine Chance. 😎",
  "Okay … Bewerbung als Autoglaser ist raus.",
  "Respekt. Das war glasklar.",
  "Stein gewinnt. Bitte nicht draußen ausprobieren.",
  "Du hast den Durchblick.",
];

export const gameLoseTexts = [
  "Tja. Deshalb gibt's uns. 😄",
  "Die Scheibe schlägt zurück.",
  "Heute gewinnt das Glas.",
  "Knapp daneben ist auch ein Steinschlag.",
  "Noch eine Runde?",
];

export const gameDrawTexts = [
  "Unentschieden. Versicherung sagt: Wir prüfen das.",
  "Glasklare Pattsituation.",
  "Stein und Scheibe einigen sich friedlich.",
  "Das klären wir beim nächsten Steinschlag.",
];

export function pickNextIndex(arr, currentIndex) {
  if (arr.length < 2) return 0;
  let i;
  do {
    i = Math.floor(Math.random() * arr.length);
  } while (i === currentIndex);
  return i;
}
